import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";

/**
 * Server-synced live visitor counter.
 * - Same number on every device (server generates a deterministic value per 15-second bucket)
 * - Refetches every 15 seconds — value only changes on the bucket boundary
 */
export default function VisitorCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    const fetchNow = async () => {
      try {
        const r = await api.get("/live/visitors");
        if (alive && typeof r.data?.count === "number") setCount(r.data.count);
      } catch { /* ignore transient */ }
    };
    fetchNow();
    const t = setInterval(fetchNow, 15_000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <div className="flex items-center gap-1.5 px-2 sm:px-2.5 py-1.5 rounded-md bg-emerald-50 border border-emerald-200" data-testid="visitor-counter" title="Users currently on Nivesh Street">
      <span className="pulse-dot inline-block w-1.5 h-1.5 rounded-full bg-emerald-500" />
      <Users className="w-3 h-3 text-emerald-700" />
      <span className="font-mono-fin text-xs font-bold text-emerald-700 tabular-nums">
        {count == null ? "—" : count.toLocaleString("en-IN")}
      </span>
      <span className="text-[9px] font-mono-fin uppercase tracking-wider text-emerald-600 hidden md:inline">Live</span>
    </div>
  );
}
